import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hovered"];
import UIFlex from 'UIComponents/layout/UIFlex';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UIPopoverBody from 'UIComponents/tooltip/UIPopoverBody';
import UIPopoverCloseButton from 'UIComponents/tooltip/UIPopoverCloseButton';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import { useCallback, useState } from 'react';
import FileAttachment from '../files/FileAttachment';
import useHovered from 'UIComponents/hooks/useHovered';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SLINKY } from 'HubStyleTokens/colors';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputFilesWrapper = ({
  input,
  value,
  fileReferences,
  property,
  popoverProps
}) => {
  const _useHovered = useHovered({}),
    {
      hovered
    } = _useHovered,
    hoveredProps = _objectWithoutPropertiesLoose(_useHovered, _excluded);
  const [showPopover, setShowPopover] = useState(true);
  const parsedValues = parseMultiEnumValue(value);
  const renderContent = () => {
    return /*#__PURE__*/_jsxs(UIPopoverBody, {
      className: "p-bottom-5",
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        justify: "between",
        children: [/*#__PURE__*/_jsxs("b", {
          children: [property.label, " (", parsedValues.length, ")"]
        }), /*#__PURE__*/_jsx(UIPopoverCloseButton, {
          onClick: () => setShowPopover(false)
        })]
      }), input]
    });
  };
  const firstReference = fileReferences && fileReferences.find(reference => reference.id === parsedValues[0]);
  const moreText = parsedValues.length > 1 ? /*#__PURE__*/_jsx("span", {
    style: {
      color: SLINKY
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.PropertyInputFilesV2.more",
      options: {
        count: parsedValues.length - 1
      }
    })
  }) : null;
  const handleOpenChange = useCallback(evt => {
    setShowPopover(evt.target.value);
  }, []);
  const handleClick = useCallback(() => {
    setShowPopover(prev => !prev);
  }, []);
  const fileValue = firstReference ? /*#__PURE__*/_jsx(FileAttachment, {
    fileReference: firstReference
  }) : '--';
  const manageButton = /*#__PURE__*/_jsx("div", {
    style: {
      flexShrink: '0'
    },
    children: hovered ? /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary-light",
      size: "extra-small",
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.PropertyInputFilesV2.manageButton"
      })
    }) : moreText
  });
  return /*#__PURE__*/_jsx(UIPopover, Object.assign({
    width: 350,
    placement: "right"
  }, popoverProps, {
    open: showPopover,
    renderContent: renderContent,
    onOpenChange: handleOpenChange,
    "data-test-id": "property-input-files-popover",
    children: /*#__PURE__*/_jsxs(UIFlex, Object.assign({
      align: "center"
    }, hoveredProps, {
      children: [fileValue, manageButton]
    }))
  }));
};
export default PropertyInputFilesWrapper;